import { createContext } from 'react';

/** Vero dentro l'azione della `Testata`: li i pulsanti su telefono sono icone. */
export const InTestata = createContext(false);
